module.exports = __webpack_public_path__ + "static/media/Room-2.930bbf36.jpg";